import React from "react";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { Box, Flex, Heading, Section, Text } from "@radix-ui/themes";

export const TermsOfUse: React.FunctionComponent = () => {
  return (
    <Flex>
      <Box>
        <Text as="p">Last updated: February 10, 2025</Text>
        <Section size="1">
          <Heading as="h2" size="4" mb="1">
            1. Introduction
          </Heading>
          <Text as="p" mb="2">
            Please read these Terms and Conditions (&ldquo;Terms&rdquo;,
            &ldquo;Terms and Conditions&rdquo;) carefully before using the{" "}
            {brand.name} website (the &ldquo;Service&rdquo;) operated by
            {brand.event.isEvent
              ? "iPlay ApS"
              : "Danmarks Bedste Gamer ApS"}{" "}
            (&ldquo;us&rdquo;, &ldquo;we&rdquo;, or &ldquo;our&rdquo;).
          </Text>
          <Text as="p" mb="2">
            Your access to and use of the Service is conditioned on your
            acceptance of and compliance with these Terms. These Terms apply to
            all visitors, users and others who access or use the Service.
          </Text>
          <Text as="p" mb="2">
            By accessing or using the Service you agree to be bound by these
            Terms. If you disagree with any part of the terms, then you may not
            access the Service.
          </Text>
        </Section>
        <Section size="1">
          <Heading as="h2" size="4" mb="1">
            2. Accounts
          </Heading>
          <Text as="p" mb="2">
            When you create an account with us, you must provide us information
            that is accurate, complete, and current at all times. Failure to do
            so constitutes a breach of the Terms, which may result in immediate
            termination of your account on our Service.
          </Text>
          <Text as="p" mb="2">
            You are responsible for safeguarding the password that you use to
            access the Service and for any activities or actions under your
            password, whether your password is with our Service or a third-party
            service.
          </Text>
          <Text as="p" mb="2">
            You agree not to disclose your password to any third party. You must
            notify us immediately upon becoming aware of any breach of security
            or unauthorized use of your account.
          </Text>
          <Text as="p" mb="2">
            Other than content you own, which you may have opted to include on
            this Website, under these Terms, iPlay ApS and/or its licensors own
            all rights to the intellectual property and material contained in
            this Website, and all such rights are reserved. You are granted a
            limited license only, subject to the restrictions provided in these
            Terms, for purposes of viewing the material contained on this
            Website.
          </Text>
        </Section>
        <Section size="1">
          <Heading as="h2" size="4" mb="1">
            3. Links to Other Web Sites
          </Heading>
          <Text as="p" mb="2">
            Our Service may contain links to third-party web sites or services
            that are not owned or controlled by iPlay ApS.
          </Text>
          <Text as="p" mb="2">
            iPlay ApS has no control over, and assumes no responsibility for,
            the content, privacy policies, or practices of any third party web
            sites or services. You further acknowledge and agree that iPlay ApS
            shall not be responsible or liable, directly or indirectly, for any
            damage or loss caused or alleged to be caused by or in connection
            with use of or reliance on any such content, goods or services
            available on or through any such web sites or services.
          </Text>
          <Text as="p" mb="2">
            We strongly advise you to read the terms and conditions and privacy
            policies of any third-party web sites or services that you visit.
          </Text>
        </Section>
        <Section size="1">
          <Heading as="h2" size="4" mb="1">
            4. Termination
          </Heading>
          <Text as="p" mb="2">
            We may terminate or suspend access to our Service immediately,
            without prior notice or liability, for any reason whatsoever,
            including without limitation if you breach the Terms.
          </Text>
          <Text as="p" mb="2">
            All provisions of the Terms which by their nature should survive
            termination shall survive termination, including, without
            limitation, ownership provisions, warranty disclaimers, indemnity
            and limitations of liability.
          </Text>
          <Text as="p" mb="2">
            We may terminate or suspend your account immediately, without prior
            notice or liability, for any reason whatsoever, including without
            limitation if you breach the Terms.
          </Text>
          <Text as="p" mb="2">
            Upon termination, your right to use the Service will immediately
            cease. If you wish to terminate your account, you may simply
            discontinue using the Service.
          </Text>
          <Text as="p" mb="2">
            All provisions of the Terms which by their nature should survive
            termination shall survive termination, including, without
            limitation, ownership provisions, warranty disclaimers, indemnity
            and limitations of liability.
          </Text>
        </Section>
        <Section size="1">
          <Heading as="h2" size="4" mb="1">
            5. Limitation of liability
          </Heading>
          <Text as="p" mb="2">
            In no event shall iPlay ApS, nor any of its officers, directors and
            employees, be liable to you for anything arising out of or in any
            way connected with your use of this Website, whether such liability
            is under contract, tort or otherwise, and iPlay ApS, including its
            officers, directors and employees shall not be liable for any
            indirect, consequential or special liability arising out of or in
            any way related to your use of this Website.
          </Text>
        </Section>
        <Section size="1">
          <Heading as="h2" size="4" mb="1">
            6. Governing Law
          </Heading>
          <Text as="p" mb="2">
            These Terms shall be governed and construed in accordance with the
            laws of Denmark, without regard to its conflict of law provisions.
          </Text>
          <Text as="p" mb="2">
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights. If any provision of
            these Terms is held to be invalid or unenforceable by a court, the
            remaining provisions of these Terms will remain in effect. These
            Terms constitute the entire agreement between us regarding our
            Service, and supersede and replace any prior agreements we might
            have between us regarding the Service.
          </Text>
        </Section>
        <Section size="1">
          <Heading as="h2" size="4" mb="1">
            7. Changes
          </Heading>
          <Text as="p" mb="2">
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time.
          </Text>
          <Text as="p" mb="2">
            By continuing to access or use our Service after those revisions
            become effective, you agree to be bound by the revised terms. If you
            do not agree to the new terms, please stop using the Service.
          </Text>
        </Section>
        <Section size="1">
          <Heading as="h2" size="4" mb="1">
            8. Participation
          </Heading>
          <Text as="p" mb="2">
            By scanning and playing you participate in a competition where the
            goal is to set the fastest lap time. Top 3 fastest participants will
            each win a prize at the end of the day and are required to collect
            their prize in person. Prizes will be handed out at 17:45, should a
            winner not show up to collect their prize by 17:55 at the latest,
            they forfeit it. Prize consists of a Lego Speed Champions F1 kit
            which is valued at 249.95 DKK MSRP
          </Text>
        </Section>
        <Section size="1">
          <Heading as="h2" size="4" mb="1">
            9. Contact Us
          </Heading>
          <Text as="p" mb="2">
            If you have any questions about these Terms, please contact us.
          </Text>
        </Section>
      </Box>
    </Flex>
  );
};
